<template>
  <div class="bg-gray-100 min-h-screen p-8">
    <!-- Header Section -->
    <header class="text-center mb-10">
      <h1 class="text-3xl font-bold text-green-700">Costs and Finances</h1>
      <p class="text-gray-700 mt-2">Understanding the financial aspects of treatment</p>
    </header>

    <!-- Section 1: Treatment Costs -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Treatment Costs</h2>
      <p class="text-gray-700">
        The cost of treatment depends on the duration and type of program chosen. Our facility offers a range of treatment plans tailored to individual needs. Contact us for specific pricing and package options.
      </p>
    </section>

    <!-- Section 2: Payment Options -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Payment Options</h2>
      <p class="text-gray-700">
        We offer flexible payment options to make treatment accessible. Payment can be made via bank transfer, credit card, or mobile money. For more details on payment methods, feel free to reach out to our finance department.
      </p>
    </section>
    
    <!-- Section 5: Planning for Treatment Costs -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Planning for Treatment Costs</h2>
      <p class="text-gray-700">
        We recommend setting a realistic budget for treatment, including potential aftercare costs. Our finance team is available to help you estimate costs and explore options to make treatment more manageable.
      </p>
    </section>

    <!-- Contact Information -->
    <section class="text-center mt-12">
      <p class="text-gray-700">For more information on costs and payment plans, please reach out to us:</p>
      <p class="text-green-700 font-semibold mt-2">Email: tpccrecovery@gmail.com | Phone: 0746 298 500 / 0723 168 719</p>
    </section>
  </div>
</template>

<script>
export default {
  name: "CostsAndFinances",
};
</script>

<style scoped>
/* Custom styles if needed */
</style>
